import * as THREE from 'three';
import { BoundaryEdges } from './getBoundaryEdges';

const EPSILON = 1e-5;
function pointsEqual(a: THREE.Vector3, b: THREE.Vector3) {
  return a.distanceTo(b) < EPSILON;
}

const MAX_ITER = 10000;

/**
 * Takes boundary edges [ [v0, v1], [v0, v1], ... ] and merges them into an array of loops,
 * each loop is an array of Vector3 in order.
 */
export function buildLoops(boundaryEdges: BoundaryEdges) {
  // We'll store each edge as an object { start: Vector3, end: Vector3, used: boolean }
  const edges = boundaryEdges.map(([vA, vB]) => ({ start: vA, end: vB, used: false }));
  const loops: THREE.Vector3[][] = [];

  edges.forEach((edge) => {
    if (edge.used) return; // skip if we've already used this edge in a loop

    const loop = [edge.start.clone(), edge.end.clone()];
    edge.used = true;

    let iter = 0;
    let searching = true;
    while (searching) {
      if (iter++ > MAX_ITER) {
        console.warn('buildLoops: MAX_ITER reached');
        break;
      }
      searching = false;
      // Try to find the next edge that starts where the last point in loop ends
      const loopEnd = loop[loop.length - 1];
      for (let j = 0; j < edges.length; j++) {
        const e2 = edges[j];
        if (!e2.used) {
          if (pointsEqual(e2.start, loopEnd)) {
            loop.push(e2.end.clone());
            e2.used = true;
            searching = true;
            break;
          } else if (pointsEqual(e2.end, loopEnd)) {
            // if reversed
            loop.push(e2.start.clone());
            e2.used = true;
            searching = true;
            break;
          }
        }
      }
    }

    loops.push(loop);
  });

  return loops;
}
